import { Avatar } from '@/components/ui/Avatar';
import { getImageUrl } from '@/utils/imageUrl';
import { ShieldCheck, FileText } from 'lucide-react';

interface ConfirmationProfessionalContainerProps {
	imgUrl: string;
	name: string;
	code: string;
	description: string | null;
}

const ConfirmationProfessionalContainer = ({
	imgUrl,
	name,
	code,
	description,
}: ConfirmationProfessionalContainerProps) => {
	const resolvedImgUrl = getImageUrl(imgUrl);

	return (
		<div className="flex w-full items-start gap-6">
			{resolvedImgUrl ? (
				<Avatar
					img_url={resolvedImgUrl}
					variant="circle"
					className="h-16 w-16 rounded-2xl text-2xl font-bold shadow-lg shadow-purple-100"
				/>
			) : (
				<div className="flex h-16 w-16 shrink-0 items-center justify-center rounded-2xl bg-purple-500 text-2xl font-bold text-white shadow-lg shadow-purple-100">
					{name?.charAt(0) ?? 'P'}
				</div>
			)}
			<div className="flex-1">
				<span className="mb-1 block text-[10px] font-bold uppercase tracking-[0.22em] text-gray-400">
					Profissional
				</span>
				<h3 className="mb-1 text-xl font-bold text-gray-900">{name}</h3>
				<div className="space-y-1 text-sm text-gray-500">
					<span className="flex items-center gap-1.5">
						<ShieldCheck className="h-3.5 w-3.5 text-emerald-500" />
						CRM ou CRP:{' '}
						<span className="font-semibold text-gray-700">
							{code}
						</span>
					</span>
					{description && (
						<span className="flex gap-1.5 text-xs sm:text-sm">
							<FileText className="h-3.5 w-3.5 pt-2 text-emerald-500" />
							<span className="text-gray-500">
								Descrição do Profissional:{' '}
								<span className="font-medium text-gray-700">
									{description}
								</span>
							</span>
						</span>
					)}
				</div>
			</div>
		</div>
	);
};

export { ConfirmationProfessionalContainer };
